import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	compactCard: {
		marginBottom: theme.spacing(1),
		"&:hover": {
			boxShadow: theme.shadows[3],
		},
	},
	compactCardContent: {
		padding: theme.spacing(1),
		"&:last-child": {
			paddingBottom: theme.spacing(1),
		},
	},
	compactGridItem: {
		padding: theme.spacing(0.5),
	},
	compactLabel: {
		marginBottom: 0,
		lineHeight: 1.2,
	},
	compactButton: {
		padding: theme.spacing(0.5, 1),
	},
	daysOverdueBox: {
		padding: theme.spacing(0.5),
	},
	previousReceiveHeaderContainer: {
		fontWeight: 600,
		marginLeft: theme.spacing(1),
	},
	centeredText: {
		textAlign: "center",
	},
	titleText: {
		fontSize: "0.575rem",
	},
	valueText: {
		fontSize: "0.75rem",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	},
	outstandingEdiInvoiceLinkContainer: {
		backgroundColor: theme.palette.background.paper,
	},
	outstandingEdiInvoiceLink: {
		marginBottom: theme.spacing(1),
		border: "1px solid rgba(0, 0, 0, 0.12)",
	},
	outstandingEdiInvoiceLinkHighlighted: {
		marginBottom: theme.spacing(1),
		border: "1px solid #028702",
		borderLeft: "5px solid #028702",
	},
}));